import { skipToken } from "@tanstack/react-query";
import { can } from "@remi/permissions";

import { api } from "~/utils/api";
import { useUserProfile } from "~/contexts/UserProfileContext";

export const usePersonLastContact = (personId?: string) => {
  const { user } = useUserProfile();
  return api.person.lastContact.useQuery(personId ? { personId } : skipToken, {
    enabled: can.person.viewDetails(user),
  });
};
